module.exports = __webpack_public_path__ + "media/img/testimonial/ophelia-fa6fe74d910b1a57c2917eeae85a4ec4.jpeg";